(function() {
    angular
        .module('validation.rule', ['validation'])
        .config(['$validationProvider', function($validationProvider) {
            var expression = {
                required: function(value, scope, element, attrs, param) {
                    // if(angular.isUndefined(value))return false;
                    return !!value;
                },
                url: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    // var URL_REGEXP = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
                    var regExp1 = /^(http:|ftp:|https:)?(\/\/)?[a-z-A-z\d]*(\.)?[a-z-A-z\d]+(\.)?[a-zA-z\d]+(\.(?:[a-zA-z\d]+))+(\:(?:\d+))?(\/?|(\/.+)?)$/; // 校验域名加端口号
                    var regExp2 = /^(http:|ftp:|https:)?(\/\/)?(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])(\:?(:\d+))?(\/?|(\/.+)?)$/;
                    return regExp1.test(value) || regExp2.test(value);
                },
                email: function(value, scope, element, attrs, param) {

                    /* var reg = new RegExp(/[\u4e00-\u9fa5]/);
                    if (reg.test(value)) {
                        scope.model = "";
                        return;
                    }*/
                    if (!value) {return true;}
                    var EMAIL_REGEXP = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                    return EMAIL_REGEXP.test(value);
                },
                unicode: function(value, scope, element, attrs, param) {
                    if (!value) {
                        return true;
                    } else if (value.length > 6) {
                        scope.model = value.slice(0, 6);
                    }
                    var UNICODE_REGEXP = /^[0-9]{6}$/;
                    return UNICODE_REGEXP.test(value);
                },
                number: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var NUMBER_REGEXP = /^\d+$/;
                    
                    return NUMBER_REGEXP.test(value);
                },
                minlength: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    return value.length >= param;
                },
                maxlength: function(value, scope, element, attrs, param) {
                    var value_ = angular.copy(value);
                    value_ = (value_ !== undefined && value_.SRCNAME !== undefined) ? value_.SRCNAME : value_; // 此处为了兼容创作分发编辑页的稿件来源一项
                    if (!value_) {return true;}
                    return value_.length <= param;
                },
                spechar: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var SPECIALCHAR_REGEXP = /[<>\/]/;
                    return !SPECIALCHAR_REGEXP.test(value);
                },
                allspechar: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var ALLSPECIALCHAR_REGEXP = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/;
                    return !ALLSPECIALCHAR_REGEXP.test(value);
                },
                custommonitorSpechar: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var CUSTOMMONITORSPECHAR_REGEXP = /[%<>\/+]/;
                    return !CUSTOMMONITORSPECHAR_REGEXP.test(value);
                },
                idcard: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var IDCARD_REGEXP = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X|x)$/;
                    return IDCARD_REGEXP.test(value);
                },
                telephone: function(value, scope, element, attrs, param) {

                    /* var reg = new RegExp(/[\u4e00-\u9fa5]/);
                    if (reg.test(value)) {
                        scope.model = "";
                        return;
                    }*/
                    if (!value) {return true;}
                    var TELPHONE_RETEXP = /(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7}/;
                    return TELPHONE_RETEXP.test(value);
                },
                mobilephone: function(value, scope, element, attrs, param) {
                    if (!value) {
                        return true;
                    } else if (value.length > 11) {
                        scope.model = scope.model.slice(0, 11);
                    }

                    /* var NUMBER_REGEXP = /^\d+$/;
                    if (!NUMBER_REGEXP.test(value)) {
                        scope.model = isNaN(parseInt(scope.model)) ? "" : parseInt(scope.model);
                    }*/
                    var MOBILEPHONE_REGEXP = /^1[0-9]{10}$/; // /^(0|86|17951)?(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[0-9])[0-9]{8}$/;
                    return MOBILEPHONE_REGEXP.test(value);
                },
                englishandnum: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var ENGLISHANDNUM_RETEXP = /^[a-zA-Z0-9]+$/;
                    return ENGLISHANDNUM_RETEXP.test(value);
                },
                ipconfig: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var IPCONFIG_RETEXP = /^(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])$/;
                    return IPCONFIG_RETEXP.test(value);
                },
                haschinese: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var HASCHINESE_RETEXP = /^[^\u4e00-\u9fa5]*$/;
                    return HASCHINESE_RETEXP.test(value);
                },
                allchar: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var ALLCHAR_RETEXP = /(?=[\x21-\x7e“”‘’、·？！（）【】]+)[^A-Za-z0-9]/;
                    return !ALLCHAR_RETEXP.test(value);
                },
                hasletter: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var NOLETTER_RETEXP = /[A-Za-z]+/;
                    return !NOLETTER_RETEXP.test(value);
                },
                filepath: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var FILEPATH_RETEX = /^[A-Za-z]:(?:\\(?!\\)|[^\\/:*?“”‘’''""<>|+-.`~#%^&;])+$/;
                    return FILEPATH_RETEX.test(value);
                },
                password: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var PASSWORD_RETEX = /(?!^[a-z]+$)(?!^[A-Z]+$)(?!^[0-9]+$)(?!^[·~!@#$%\^&*()_\-=+{}\[\]【】\\|:;'",.<>/?]+$)(?!^[^\x21-\x7e]+$)^.+$/;
                    return PASSWORD_RETEX.test(value);
                },
                newFolder: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var NEWFOLDER_RETEXP = /^[~|\$|\.|_].*/;
                    return !NEWFOLDER_RETEXP.test(value);
                },
                numb: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var NUMB_RETEXP = /^[-+]?\d*$/;
                    return !NUMB_RETEXP.test(value);
                },
                charAndNum: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var NUMB_RETEXP = /^(?=.*[0-9])(?=.*[a-zA-Z])(.{4,})$/;
                    return NUMB_RETEXP.test(value);
                },
                charAndNumAndSpechar: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var NUMB_RETEXP = /^(?=.*[a-z])(?=.*\d)(?=.*[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、])[A-Za-z\d`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]{8,16}$/;
                    return NUMB_RETEXP.test(value);
                },
                hasnumber: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var NUMB_RETEXP = /[0-9]+/;
                    return !NUMB_RETEXP.test(value);
                },
                onlyenglish: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var ENGLISHANDNUM_RETEXP = /^[a-zA-Z]+$/;
                    return ENGLISHANDNUM_RETEXP.test(value);
                },
                nothaszero: function(value, scope, element, attrs, param){
                    if (!value) {return true;}
                    var NUMBER_REGEXP = /^(?!0)\d{1,3}$|^0$/;
                    return NUMBER_REGEXP.test(value);
                },
                numberrange: function(value, scope, element, attrs, param){
                    value = parseInt(value);
                    if (value === 0) {return false;} else if (value > attrs.numberangeset) {return false;} else {return true;}
                },
                isvideoiframe: function(value, scope, element, attrs, param) {
                    if (!value) {return true;}
                    var VIDEOFRAME_RETEX = /<iframe\s+[^>]*src=[\"\']([^\"\']*)[\"\'][^>]*><\/iframe>/;
                    return VIDEOFRAME_RETEX.test(value);
                }
            };

            var defaultMsg = {
                required: {
                    error: '这是必填项！',
                    success: 'It\'s Required'
                },
                url: {
                    error: 'url格式不正确！',
                    success: 'It\'s Url'
                },
                email: {
                    error: 'Email格式不正确！',
                    success: 'It\'s Email'
                },
                number: {
                    error: '只能填写正整数！',
                    success: 'It\'s Number'
                },
                minlength: {
                    error: '长度太短了！',
                    success: 'Long enough!'
                },
                maxlength: {
                    error: '长度太长了！',
                    success: 'Short enough!'
                },
                spechar: {
                    error: '不能包含特殊字符！',
                    success: 'OK!'
                },
                allspechar: {
                    error: '不能包含任何特殊字符！',
                    success: 'OK!'
                },
                custommonitorSpechar: {
                    error: '不能包含特殊字符！',
                    success: 'OK!'
                },
                idcard: {
                    error: '身份证号码错误！',
                    success: 'OK!'
                },
                telephone: {
                    error: '固定电话格式错误！',
                    success: 'OK!'
                },
                mobilephone: {
                    error: '手机号码格式错误！',
                    success: 'OK!'
                },
                englishandnum: {
                    error: '请输入只含有英文字母、数字的名称',
                    success: 'OK!'
                },
                ipconfig: {
                    error: '请输入正确输入服务器地址.',
                    success: 'OK!'
                },
                haschinese: {
                    error: '不能包含汉字',
                    success: 'OK!'
                },
                allchar: {
                    error: '不能包含符号',
                    success: 'OK!'
                },
                hasletter: {
                    error: '不能包含字母',
                    success: 'OK!'
                },
                filepath: {
                    error: '请输入正确的文件存放路径',
                    success: 'OK!'
                },
                password: {
                    error: '须包含大写字母、小写字母、数字、特殊字符中的2种',
                    success: 'OK!'
                },
                newFolder: {
                    error: '不能以~ 、. 、 _ 、 $ 开头',
                    success: 'OK!'
                },
                numb: {
                    error: '只能填写整数！',
                    success: 'OK!'
                },
                charAndNum: {
                    error: '至少8个字符,需同时包含字母和数字',
                    success: 'OK!'
                },
                charAndNumAndSpechar: {
                    error: '8~16个字符，必须包含数字、小写字母和符号',
                    success: 'OK!'
                },
                unicode: {
                    error: '邮编格式错误',
                    success: 'OK!'
                },
                hasnumber: {
                    error: '不能包含数字',
                    success: 'OK!'
                },
                onlyenglish: {
                    error: '只能输入大小写英文',
                    success: 'OK!'
                },
                nothaszero: {
                    error: '不能以数字0开头',
                    success: 'OK!'
                },
                numberrange: {
                    error: '不能小于1大于最大数值',
                    success: 'OK!'
                },
                isvideoiframe: {
                    error: '必须是视频网站分享的通用代码',
                    success: 'OK!'
                }
            };
            $validationProvider.setExpression(expression).setDefaultMsg(defaultMsg);
        }]);
}).call(this);
